const seconds = 1000;
const minutes = 60 * seconds;

const team_puo = 0;
const team_toezichthouder = 1;
const team_media = 2;

module.exports = {
    states_three: [
        {
            dilemmaId: "no-scenario",
            title: 'Geen scenario actief',
            teams: [team_puo, team_media, team_toezichthouder],
            answers: [], 
            duration: -1, 
            startAfter: -1, 
            isRead: true
        }
    ]
};